module.exports = __webpack_public_path__ + "img/66.53ac9762.jpg";